import {z} from 'zod';

/**
 * Every rate a financing or leasing offer advertises is a finite, non-negative percentage. The
 * validation messages come from the translated zod error map installed in `@dms/i18n`, so a
 * missing rate reads as required and a negative one names the minimum without a message here.
 */
export const financingRateSchema = z.number().finite().nonnegative();
